import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'formik';
import classnames from 'classnames';
import { FormGroup } from 'reactstrap';

class TextAreaField extends Component {
  state = {
    focusedField: false,
  };

  render() {
    let required = false;
    const { className } = this.props;

    if (typeof this.props.required === 'boolean') {
      required = this.props.required;
    }

    return (
      <FormGroup
        className={classnames({
          focused: this.state.focusedField,
        })}
      >
        <FormattedMessage id={ this.props.messageId }>
          {placeHolder =>
            <Field as="textarea"
              className={ `form-control` + (className ? ` ${className}` : '')}
              name={ this.props.name }
              placeholder={ `${placeHolder}` + (required === true ? ' *' : '') }
              onChange={ (event) => this.props.handleChange(event.target.value) }
              onFocus={() => {
                if (this.props.focusEffect)
                  this.setState({ focusedField: true })
              }}
              onBlur={ e => {
                this.props.handleBlur(e);

                if (this.props.focusEffect)
                  this.setState({ focusedField: false })
              }}
              resize="none"
            />
          }
        </FormattedMessage>
      </FormGroup>
    );
  }
}

TextAreaField.defaultProps = {
  name: 'message',
  autoComplete: 'on',
  focusEffect: true,
  className: null,
};

export { TextAreaField };
